<template>
  <div id="index">
    <common-header></common-header>
    <!-- メッセージ -->
      <div v-if="isError" class="errorArea">
        <v-alert
          :value="true"
          type="error"
          outline
        >
          {{errorMessage}}
        </v-alert>
      </div>
      <!-- /メッセージ -->
    <div class="edit-wrapper" v-if="!isLoading">
      <p class="title"><v-icon>edit</v-icon>平成年表のタイトル</p>
      <v-layout class="title-wrapper" row>
        <v-flex xs9 md10>
          <input class="title-text" type="text" placeholder="タイトルをご記入ください。" v-model="title"/>
        </v-flex>
        <v-flex xs3 md2>
          <p style="font-size:16pt;padding-top:9px;padding-left:5px;">の年表</p>
        </v-flex>
      </v-layout>
      <p class="title"><v-icon>photo</v-icon>トップ画像</p>
      <input type="file" style="display: none;" ref="image" v-on:change="onFileChange" mulitple="multiple">
      <div v-if="uploadedImageForView==undefined" style="text-align:center;margin-bottom: 26px;">
        <v-btn large color="grey" dark @click="pickImage"><v-icon>add_a_photo</v-icon>&nbsp; 画像を追加する</v-btn>
        <p><span>画像は省略可能です。</span></p>
      </div>
      <div v-else style="text-align:center;margin-bottom:16px;">
        <img :src="uploadedImageForView" style="max-width:80%;max-heght:300px;">
        <v-btn fab dark small color="primary" @click="clearImage()" style="position:relative;right:20px;">
          <v-icon>clear</v-icon>
        </v-btn>
      </div>
      <p class="title"><v-icon>edit</v-icon>年表編集
        <span class="select_birthday_wrapper">
          生まれた年：
          <select class="select_birthday" v-model="birthYear">
            <option v-for="(y, id) in years" :key="id" :value="id">
              {{y}}
            </option>
          </select>
        </span>
      </p>
      <p style="margin-bottom:0;" class="red--text">※生まれた年を選択すると年齢から年選択ができます。</p>
      <div class="nenpyo">
        <ul>
          <draggable :options="{group:'ITEMS'}" v-model="rows">
            <li v-for="(row,id) in rows" :key="id">
              <v-layout row wrap>
                <v-flex md2 xs3 d-flex>
                  <select class="select-year" v-model="row.year" @change="onSelectChanged(id)">
                    <option value="">年選択</option>
                    <option v-for="(nen, id) in displayNens" :key="id" :value="id">
                      {{nen}}
                    </option>
                  </select>
                </v-flex>
                <v-flex md9 xs8>
                  <textarea placeholder="出来事などご記入ください。
改行もできます。" rows="3" v-model="row.content"></textarea></v-flex>
                <v-flex xs1>
                  <v-btn color="black" small icon dark @click="deleteRow(id)" class="close-btn"><v-icon>close</v-icon></v-btn>
                </v-flex>
              </v-layout>
            </li>
          </draggable>
        </ul>
      </div>
      <p style="margin-bottom:0;" class="red--text">※ドラッグ＆ドロップで並び替えられます。</p>
      <v-btn block color="black" small dark @click="addRow"><v-icon>add</v-icon>年表の行を追加する</v-btn>
      <p class="title" style="margin-top:24px;"><v-icon>edit</v-icon>自由記入欄</p>
      <textarea placeholder="年表への想いなどご記入ください。" rows="5" v-model="message" class="message"></textarea>
      <v-btn block color="red" dark large @click="onSave"><v-icon>send</v-icon>&nbsp;保存する</v-btn>
      <p v-if="isError" style="text-align:center" class="red--text">エラーがあります。ページトップを確認ください。</p>
    </div>
    <v-flex xs12 style="text-align:center;padding-top: 160px;" v-if="isLoading">
      <v-progress-circular class="isLoading" v-show="isLoading" :size="70" :width="7" color="red" indeterminate></v-progress-circular>
    </v-flex>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { db } from '../main'
import firebase from 'firebase'
import draggable from 'vuedraggable'
import CommonHeader from './common/CommomHeader'
import CommonFooter from './common/CommomFooter'
import LoginPart from './auth/Login'
var md5 = require('md5')
let fileExtensions = ['jpg', 'jpeg', 'png', 'bmp', 'gif']
let maxWidth = 600
let maxHeight = 600
var FileUploadThumbnail = require('file-upload-thumbnail')
export default {
  name: 'Index',
  data () {
    return {
      mode: 'new',
      title: '',
      id: '',
      timestamp: undefined,
      rows: [
        {year: '', content: ''},
        {year: '', content: ''},
        {year: '', content: ''}
      ],
      post_rows: [],
      message: '',
      isLoading: false,
      nens: ['平成元年　（1989年）', '平成2年 　（1990年）', '平成3年 　（1991年）', '平成4年 　（1992年）', '平成5年 　（1993年）', '平成6年 　（1994年）', '平成7年 　（1995年）', '平成8年 　（1996年）', '平成9年 　（1997年）', '平成10年　（1998年）', '平成11年　（1999年）', '平成12年　（2000年）', '平成13年　（2001年）', '平成14年　（2002年）', '平成15年　（2003年）', '平成16年　（2004年）', '平成17年　（2005年）', '平成18年　（2006年）', '平成19年　（2007年）', '平成20年　（2008年）', '平成21年　（2009年）', '平成22年　（2010年）', '平成23年　（2011年）', '平成24年　（2012年）', '平成25年　（2013年）', '平成26年　（2014年）', '平成27年　（2015年）', '平成28年　（2016年）', '平成29年　（2017年）', '平成30年　（2018年）', '平成31年　（2019年）', '令和元年　（2019年）', '令和2年　（2020年）'],
      isError: false,
      errorMessage: '',
      comment_count: undefined,
      birthYear: '',
      years: [],
      uploadedImageForView: undefined,
      uploadedImage: undefined,
      release: false
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.view.isLogin
    },
    displayNens () {
      if (this.birthYear === '') {
        return this.nens
      } else {
        let init = 1989
        let birth = Number(this.years[this.birthYear])
        let displayNens = []
        for (let i = 0; i < this.nens.length; i++) {
          let age = init + i - birth
          let text = this.nens[i] + '　' + age + '歳'
          if (age < 0) text = this.nens[i] + '未誕生'
          displayNens.push(text)
        }
        return displayNens
      }
    },
    releaseText () {
      if (this.release) {
        return '公開'
      } else {
        return '未公開'
      }
    }
  },
  mounted () {
    this.mode = this.$route.params.obj.mode
    if (this.mode === 'new') {
      let timestamp = new Date()
      let uid = firebase.auth().currentUser.uid
      this.id = md5(uid + timestamp)
      this.timestamp = timestamp
      this.comment_count = 0
    } else if (this.mode === 'edit') {
      let content = this.$route.params.obj.content
      this.id = this.$route.params.obj.id
      this.title = content.title
      this.rows = content.rows
      this.message = content.message
      this.timestamp = content.timestamp
      this.comment_count = content.comment_count
      if (content.image !== undefined) {
        this.uploadedImageForView = content.imageUrl
        this.uploadedImage = 'saved'
      }
      this.release = content.release
    }
    for (let i = 1950; i <= 2018; i++) {
      this.years.push(i)
    }
  },
  methods: {
    onSave () {
      this.save()
    },
    save () {
      this.post_rows = []
      for (let i = 0; i < this.rows.length; i++) {
        let r = this.rows[i]
        if (r.year === '' && r.content === '') {
        } else {
          this.post_rows.push(r)
        }
      }
      if (!this.validate()) return
      this.isLoading = true
      let saveData = {
        title: this.title,
        rows: this.post_rows,
        message: this.message,
        uid: firebase.auth().currentUser.uid,
        displayName: this.$store.state.view.displayName,
        profileImageUrl: this.$store.state.view.profileImageUrl,
        timestamp: this.timestamp,
        comment_count: this.comment_count,
        type: 'simple',
        release: this.release
      }
      // image
      if (this.uploadedImage !== undefined) {
        let fname = 'image.png'
        saveData.image = fname
        if (this.uploadedImage !== 'saved') {
          let storageRef = firebase.storage().ref()
          let imageRef = storageRef.child('chronology/' + this.id + '/' + fname)
          imageRef.put(this.uploadedImage).then((snapshot) => {
          })
        }
      }
      db.collection('chronology').doc(this.id).set(saveData)
        .then(function () {
          alert('投稿ありがとうございます！！\r\n年表を保存しました。')
          this.isLoading = false
          this.$router.push({name: 'Chronology', params: {id: this.id}})
        }.bind(this))
        .catch(function (error) {
          alert('エラーです。申し訳ございません。\r\n再度保存をお願いいたします。')
          console.error(error)
          this.isLoading = false
        }.bind(this))
    },
    pickImage () {
      this.$refs.image.click()
    },
    onFileChange (e) {
      let files = e.target.files || e.dataTransfer.files
      // ファイルのチェック
      // ファイルタイプ
      var myFileType = files[0].type
      var fileTypeCheck = false
      for (var i = 0; i < fileExtensions.length; i++) {
        var fileExtension = fileExtensions[i]
        if (myFileType.indexOf(fileExtension) > -1) {
          fileTypeCheck = true
          break
        }
      }
      if (!fileTypeCheck) {
        this.isError = true
        this.errorMessage = 'アップロードできるファイルは画像のみです。'
        return
      }
      new FileUploadThumbnail({
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        file: files[0],
        onSuccess: function (src) {
          this.uploadedImageForView = src
          // base64 => blob
          let barr, bin, i, len
          bin = atob(src.split('base64,')[1])
          len = bin.length
          barr = new Uint8Array(len)
          i = 0
          while (i < len) {
            barr[i] = bin.charCodeAt(i)
            i++
          }
          let blob = new Blob([barr], {type: 'image/jpeg'})
          this.uploadedImage = blob
        }.bind(this)
      }).createThumbnail()
    },
    clearImage () {
      this.uploadedImageForView = undefined
      this.uploadedImage = undefined
    },
    validate () {
      this.isError = false
      this.errorMessage = ''
      if (this.title.length < 1) {
        this.isError = true
        this.errorMessage = 'タイトルは1文字以上入力してください。'
        return false
      }
      if (this.title.length > 100) {
        this.isError = true
        this.errorMessage = 'タイトルは最大100文字までです。'
        return false
      }
      if (this.post_rows.length > 100) {
        this.isError = true
        this.errorMessage = '年表は最大100行です。'
        return false
      }
      if (this.post_rows.length < 1) {
        this.isError = true
        this.errorMessage = '年表は1行以上は入力してください'
        return false
      }
      if (this.message > 1000) {
        this.isError = true
        this.errorMessage = '自由記入欄は最大1000文字です。'
        return false
      }
      for (let i = 0; i < this.post_rows.length; i++) {
        if (this.post_rows[i].content.lenght > 1000) {
          this.isError = true
          this.errorMessage = '年表は1行最大1000文字です。'
          return false
        }
      }
      return true
    },
    addRow () {
      let obj = {year: '', content: ''}
      if (this.rows.length > 0) {
        if (this.rows[this.rows.length - 1].year !== '') {
          obj.year = this.rows[this.rows.length - 1].year
        }
      }
      this.rows.push(obj)
    },
    deleteRow (id) {
      if (this.rows[id].content === '') {
        this.rows.splice(id, 1)
      } else if (confirm('行を削除します。よろしいですか？')) {
        this.rows.splice(id, 1)
      }
    },
    onSelectChanged (id) {
      let y = this.rows[id].year
      if (id === this.rows.length - 1) return
      for (let i = id + 1; i < this.rows.length; i++) {
        if (this.rows[i].year === '') {
          this.rows[i].year = y
        }
      }
    },
    onMoveEnd () {
      console.log(this.rows)
    }
  },
  components: {
    CommonHeader,
    CommonFooter,
    LoginPart,
    draggable
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../assets/css/common.css");
ul{
  padding-left: 0 !important;
}
li{
  list-style: none;
}
.edit-wrapper{
  width: 100%;
  max-width: 700px;
  margin: 36px auto;
  padding: 0 10px;
}
.errorArea{
  width: 100%;
  max-width: 700px;
  margin: 0px auto;
}
.nenpyo{
  margin-top: 10px;
}
.v-text-field__details{
  margin-bottom: 0px !important;
}
p.title{
  margin-bottom: 5px;
}
.title-wrapper{
  margin-bottom:16px;
}
.title-text{
  border: solid 1px #9f9f9f;
  border-radius: 5px;
  width: 100%;
  height: 50px;
  padding-left: 5px;
  font-size: 110%;
}
.select-year{
  border: solid 1px #9f9f9f;
  width: 100%;
  height: 70px;
  padding-left: 1px;
  font-size: 110%;
  -webkit-appearance:menulist-button !important;
  -moz-appearance:menulist-button !important;
}
textarea{
  border-bottom: solid 1px #9f9f9f;
  border-top: solid 1px #9f9f9f;
  border-right: solid 1px #9f9f9f;
  width: 100%;
  height: 70px;
  padding-left: 5px;
  font-size: 110%;
}
.close-btn{
  margin-top: 20px;
}
.message{
  border: solid 1px #9f9f9f;
  border-radius: 5px;
  width: 100%;
  height: 150px;
  padding-left: 5px;
  font-size: 110%;
}
.select_birthday{
  border: solid 1px #9f9f9f;
  color: #666;
  background: #fff;
  width: 100px;
  -webkit-appearance:menulist-button !important;
  -moz-appearance:menulist-button !important;
}
.select_birthday_wrapper{
  padding: 5px 10px;
  margin-left: 5px;
  font-size: 11pt;
  color: #fff;
  border-radius: 8px;
  background: #9f9f9f;
  /* border: solid 1px #F44336; */
}
.normal {
  background-color: grey;
}
.dragArea{
  min-height: 10px;
}
.sortable-chosen {
  opacity: 0.7;
  background-color:#fff;
}
.sortable-ghost {
  background-color:#dcdcdc;
}
</style>



// WEBPACK FOOTER //
// src/components/Edit.vue